var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOwner)?_c('v-icon',{staticClass:"icon--owner",attrs:{"color":"#F8B234"}},[_vm._v("mdi-account-star")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }